import React from "react";
import { Volume2 } from "lucide-react";
import { speak } from "../services/phonicsAudio";
import { sfx } from "../services/soundfx";

// Big high-contrast read-aloud button. kind: text | word | phoneme
export default function AudioButton({ text, kind = "text", size = 64, className = "", testId = "audio-button", label }) {
  const handle = () => {
    sfx.unlock();
    speak(text, kind);
  };
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handle}
      aria-label={label || `Play audio: ${text}`}
      className={`pop-btn no-select animate-pulse-glow inline-flex items-center justify-center rounded-full bg-amber-400 text-white border-4 border-white shadow-[0_6px_0_#D97706] active:shadow-none ${className}`}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
    >
      <Volume2 strokeWidth={2.5} style={{ width: size * 0.5, height: size * 0.5 }} />
    </button>
  );
}
